import { jsx as L, jsxs as t } from "react/jsx-runtime";
import "react";
var a = (l) => /* @__PURE__ */ t("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...l,
  children: [
    /* @__PURE__ */ L("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ L("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-1392 -68)",
      fill: "white"
    }),
    /* @__PURE__ */ L("path", {
      d: "M20 0H0V20H20V0Z",
      fill: "#A2001D"
    }),
    /* @__PURE__ */ L("path", {
      d: "M19.9996 13.4783H5.86914V20H19.9996V13.4783Z",
      fill: "#6DA544"
    }),
    /* @__PURE__ */ L("path", {
      d: "M0.760858 18.0281L1.84781 16.087L2.93476 18.0281L4.02171 16.087L5.10866 18.0281L4.02187 20H5.86964V19.9999V13.4783V12.6087V0H4.02187L5.10878 1.94094L4.02183 3.91293L2.93488 1.94094L1.84793 3.91293L0.760936 1.94094L1.84777 0H0V13.4783V20H1.84777L0.760858 18.0281ZM4.02179 14.6377L2.93484 12.6657L1.84789 14.6377L0.760936 12.6657L1.84789 10.7246L2.93484 12.6657L4.02179 10.7246L5.10874 12.6657L4.02179 14.6377ZM1.84781 5.36227L2.93476 7.30336L4.02171 5.36227L5.10866 7.30336L4.02171 9.27535L2.93476 7.30336L1.84781 9.27535L0.760858 7.30336L1.84781 5.36227Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M2.93457 18.0281L1.84766 20H4.0214L2.93457 18.0281Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M2.93457 1.94094L4.02148 0H1.84766L2.93457 1.94094Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M5.10945 7.30334L4.0225 5.36224L2.93555 7.30334L4.0225 9.27533L5.10945 7.30334Z",
      fill: "#A2001D"
    }),
    /* @__PURE__ */ L("path", {
      d: "M1.84867 9.27533L2.9357 7.30334L1.84867 5.36224L0.761719 7.30334L1.84867 9.27533Z",
      fill: "#A2001D"
    }),
    /* @__PURE__ */ L("path", {
      d: "M4.0225 10.7247L2.93555 12.6658L4.0225 14.6378L5.10945 12.6658L4.0225 10.7247Z",
      fill: "#A2001D"
    }),
    /* @__PURE__ */ L("path", {
      d: "M0.761719 12.6658L1.84867 14.6378L2.9357 12.6658L1.84867 10.7247L0.761719 12.6658Z",
      fill: "#A2001D"
    }),
    /* @__PURE__ */ L("path", {
      d: "M5.10945 18.0281L4.0225 16.087L2.93555 18.0281L4.02238 20H4.02258L5.10945 18.0281Z",
      fill: "#A2001D"
    }),
    /* @__PURE__ */ L("path", {
      d: "M2.9357 18.0281L1.84867 16.087L0.761719 18.0281L1.84863 20H1.84879L2.9357 18.0281Z",
      fill: "#A2001D"
    }),
    /* @__PURE__ */ L("path", {
      d: "M2.93555 1.94094L4.0225 3.91297L5.10945 1.94094L4.02258 0H4.02246L2.93555 1.94094Z",
      fill: "#A2001D"
    }),
    /* @__PURE__ */ L("path", {
      d: "M0.761719 1.94094L1.84867 3.91297L2.9357 1.94094L1.84879 0H1.84863L0.761719 1.94094Z",
      fill: "#A2001D"
    })
  ]
});
export {
  a as default
};
